import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-transaction-private-code-confirmed-dialog',
  templateUrl: './transaction-private-code-confirmed-dialog.component.html',
  styleUrls: ['./transaction-private-code-confirmed-dialog.component.scss']
})
export class TransactionPrivateCodeConfirmedDialogComponent implements OnInit {

  form: FormGroup;

  constructor(public ngbModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      code: ['', Validators.required]
    });

  }

  closeModal() {
    this.ngbModal.close();
  }

  onSubmit() {
    if (this.form.valid) {
      const code = this.form.get('code').value;
      console.log('Entered Code:', code);
      this.ngbModal.close(code); // Optionally, pass the code back to the caller
    }
  }
}
